export default __webpack_public_path__ + "static/media/SAS Alert Tone 18.f0d1de3d.mp3";